// Match the complete-pair checks used by both SVG export serializers.
export function emptySatinLayers(svg, settings = {}, rails = {}, activePassOnly = false) {
  return (svg?.children || []).flatMap((layer, index) => {
    const entry = settings[index];
    const passes = entry?.passes || (entry ? [entry] : []);
    const exported = activePassOnly ? [passes[entry?.activePassIndex || 0]] : passes;
    if (!exported.some(p => (p?.stitchType || p?.fill_method) === 'satin')) return [];
    const r = rails[index];
    if ((r?.pairs || []).some(p => p?.rail0 && p?.rail1) || (r?.rail0 && r?.rail1)) return [];
    return [{index, label: `Layer ${index + 1}`}];
  });
}
